export * from './NavBarDetailsMobile';
export * from './NavBarDetailsDesktop';
